module.exports = __webpack_public_path__ + "static/15-71b923988f1a0553bd2be725fc0929bf.jpg";